<template src="./template.html"></template>

<script>
export default {
  name: 'web-pay-icon',
  props: {},
  computed: {},
  data() {
    return {}
  },
}
</script>



// WEBPACK FOOTER //
// src/components/WebPayIcon/index.vue